/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationQueryTopicsLiveTopicsQueryResponse, NlpIntegrationQueryTopicsLiveTopicsPathParams, NlpIntegrationQueryTopicsLiveTopicsQueryParams, NlpIntegrationQueryTopicsLiveTopics401, NlpIntegrationQueryTopicsLiveTopics403 } from "../models/NlpIntegrationQueryTopicsLiveTopics";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { nlpIntegrationQueryTopicsLiveTopics } from "../axios/nlpIntegrationQueryTopicsLiveTopics";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const nlpIntegrationQueryTopicsLiveTopicsQueryKey = (slug: NlpIntegrationQueryTopicsLiveTopicsPathParams["slug"], params: NlpIntegrationQueryTopicsLiveTopicsQueryParams = {}) => ["api-v2", { url: '/nlp-integration/v1/live-topics/:slug/topics', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type NlpIntegrationQueryTopicsLiveTopicsQueryKey = ReturnType<typeof nlpIntegrationQueryTopicsLiveTopicsQueryKey>

export function nlpIntegrationQueryTopicsLiveTopicsQueryOptions(slug: NlpIntegrationQueryTopicsLiveTopicsPathParams["slug"], params?: NlpIntegrationQueryTopicsLiveTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = nlpIntegrationQueryTopicsLiveTopicsQueryKey(slug, params)
        return queryOptions<NlpIntegrationQueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<NlpIntegrationQueryTopicsLiveTopics401 | NlpIntegrationQueryTopicsLiveTopics403>, NlpIntegrationQueryTopicsLiveTopicsQueryResponse, typeof queryKey>({
         enabled: !!(slug),
         queryKey,
         queryFn: async ({ signal }) => {
            return nlpIntegrationQueryTopicsLiveTopics(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Query topics by start time for timeline views.
 * @summary Query topics by time range
 * {@link /nlp-integration/v1/live-topics/:slug/topics}
 */
export function useNlpIntegrationQueryTopicsLiveTopics<TData = NlpIntegrationQueryTopicsLiveTopicsQueryResponse, TQueryData = NlpIntegrationQueryTopicsLiveTopicsQueryResponse, TQueryKey extends QueryKey = NlpIntegrationQueryTopicsLiveTopicsQueryKey>(slug: NlpIntegrationQueryTopicsLiveTopicsPathParams["slug"], params?: NlpIntegrationQueryTopicsLiveTopicsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<NlpIntegrationQueryTopicsLiveTopicsQueryResponse, ResponseErrorConfig<NlpIntegrationQueryTopicsLiveTopics401 | NlpIntegrationQueryTopicsLiveTopics403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? nlpIntegrationQueryTopicsLiveTopicsQueryKey(slug, params)
         

         const query = useQuery({
          ...nlpIntegrationQueryTopicsLiveTopicsQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NlpIntegrationQueryTopicsLiveTopics401 | NlpIntegrationQueryTopicsLiveTopics403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}